import { render, staticRenderFns } from "./ExamSimulationItem.vue?vue&type=template&id=6b4b9a58&scoped=true&"
import script from "./ExamSimulationItem.vue?vue&type=script&lang=js&"
export * from "./ExamSimulationItem.vue?vue&type=script&lang=js&"
import style0 from "./ExamSimulationItem.vue?vue&type=style&index=0&id=6b4b9a58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4b9a58",
  null
  
)

export default component.exports